import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {TokenService} from '../../../../core/auth';
import {Project} from '../../../../core/models';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {ProjectSidebarService} from '../../../../projectsidebar.service';
import {AppComponent} from "../../../../app.component";
import {WebhookService} from "../../../../core/services";
import {combineLatest, Subject} from "rxjs";
import {DataTable} from "primeng/datatable";
import {debounceTime, distinctUntilChanged, map} from "rxjs/operators";
import {WebhookRequest, WebhookResponse} from "../../../../core/models/webhook";


@Component({
  selector: 'app-project-webhook-list',
  templateUrl: './project-webhook-list.page.html'
})
export class ProjectWebhookListPage implements OnInit {



  authUser = this.token.whoAmI();
  loading = false;
  busy = false;
  error = false;

  projectId: string;
  project: Project;

  @Input() request = new WebhookRequest();
  response = new WebhookResponse();

  @ViewChild('dt') dt: DataTable;
  searchTerms = new Subject<WebhookRequest>();

  cols: any[];
  _selectedColumns: any[];


  constructor(
      private cdRef: ChangeDetectorRef,
      private app: AppComponent,
      private route: ActivatedRoute,
      private router: Router,
      private token: TokenService,
      private breadcrumbService: BreadcrumbService,
      private projectSidebarService: ProjectSidebarService,
      private webhookService: WebhookService
  ) {
  }


  ngOnInit() {
    this.initColumns();

    this.error = false;
    this.loading = true;

    combineLatest(new Array(this.route.parent.data))
        .pipe(map(results => ({
          project: results[0].project,
          projectId: results[0].project.id,
        })))
        .subscribe(result => {
              this.project = result.project;
              this.projectId = result.projectId;

              this.projectSidebarService.setProject(this.project);

              this.breadcrumbService.setItems([
                {label: 'projects', routerLink: ['/project']},
                {label: this.project.name, routerLink: ['/project', this.project.id, 'dashboard']},
                {label: 'webhooks', routerLink: ['/project', this.project.id, 'webhooks']},
              ]);

              this.searchTerms.pipe(
                  debounceTime(1000),
                  distinctUntilChanged())
                  .subscribe(value => {
                    this.dt.reset();
                  });

              this.loading = false;
              this.cdRef.detectChanges();
            },
            () => {
              this.error = true;
              this.loading = false;
              this.cdRef.detectChanges();
            });
  }

  initColumns() {
    this.cols = [
      { field: 'creationDate', header: 'Created', sortField: 'creationDate', type: 'DATE', class: 'text-center', default: true, width: '10%' },
      { field: 'method', header: 'Method', sortField: 'method', type: 'METHOD', class: 'text-center', default: true, width: '10%' },
      { field: 'protocol', header: 'Protocol', sortField: 'protocol', type: 'PROTOCOL', class: 'text-center', default: true, width: '10%' },
      { field: 'path', header: 'Path', sortField: 'path', type: 'TEXT', class: 'overflow-ellipsis', default: true, width: '60%' }
    ];

    this._selectedColumns = this.cols.filter(col => col.default);
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  load(event) {
    this.busy = true;
    this.request.page = (event.first / event.rows) + 1;
    this.request.projectId = this.projectId;
    this.request.sortField = !event.sortField ? 'path' : event.sortField;
    this.request.sortDir = event.sortOrder === 1  ? 'asc' : 'desc';

    this.webhookService.find(this.projectId, this.request).subscribe(
        (data) => {
          this.response = data;
          this.busy = false;
        },
        () => {
          this.error = true;
          this.busy = false;
        }
    );
  }

  navigateToAdd() {
    this.router.navigate(['project', this.projectId, 'webhook']);
  }

}
